<template>
  <div class="amount-box" :style="{ color }">
    <span class="decimal" :class="{ 'small-decimal': smallInt, 'mini-decimal': miniInt }">¥</span>
    <span class="int" :class="{ 'small-int': smallInt, 'mini-int': miniInt }">{{ intPrice }}</span>
    <template v-if="decimalPrice">
      <span class="dot">.</span>
      <span class="decimal" :class="{ 'small-decimal': smallInt, 'mini-decimal': miniInt }">{{ decimalPrice }}</span>
    </template>
  </div>
</template>
<script setup>
import { computed } from 'vue'
const props = defineProps({
  price: {
    type: Number,
    default: 0
  },
  color: {
    type: String,
    default: '#fe2c38'
  }
})
const priceStrArr = computed(() => (props.price + '').trim().split('.'))
const intPrice = computed(() => priceStrArr.value[0])
const decimalPrice = computed(() => priceStrArr.value[1])

const smallInt = computed(() => (decimalPrice.value ? intPrice.value.length === 3 : intPrice.value.length === 4))
const miniInt = computed(() => (decimalPrice.value ? intPrice.value.length === 4 : intPrice.value.length === 5))
</script>

<style lang="less" scoped>
.amount-box {
  // font-weight: 900;
  font-family: 'Avenir';
  .int {
    font-size: 30px;
  }
  .decimal {
    font-size: 20px;
  }
  .small-int {
    font-size: 28px;
  }
  .mini-int {
    font-size: 24px;
  }
  .small-decimal {
    font-size: 16px;
  }
  .mini-decimal {
    font-size: 12px;
  }
}
</style>
